import { createFileRoute } from '@tanstack/react-router';

/**
 * `/app-integrations/$id/...` 配下の任意サブパスを親 layout (`_$id.tsx`) の
 * beforeLoad redirect に乗せるためのスプラットルート。このルート自体は match されると
 * 親の beforeLoad が先に動いて redirect されるため、component の実装は不要。
 */
export const Route = createFileRoute('/_staff/app-integrations/$id/_$id/$')({});